import { connect } from "react-redux";
import B2BAlliancesFollowUp from "./b2BAlliancesFollowUp";
import { bindActionCreators } from "redux";
import {
  getFollowUpDropDown,
  saveFollowUp,
} from "services/redux/sales/followUpForm/action";
import { addPoc } from "services/redux/sales/poc/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";


const mapStateToProps = (state) => ({
  followUpDropDown: state.followUpFormReducer.followUpDropDown,
  followUpSuccess: state.followUpFormReducer.followUpSuccess,
  pocDetails: state.pocReducer.pocDetails,
  pocById: state.pocReducer.pocById,
  documentUrlData: state.fileUploadReducer.documentUrlData,

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getFollowUpDropDown,
      saveFollowUp,
      addPoc,
      documentUploadUrl
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(B2BAlliancesFollowUp);
